import {
  FETCH_PRODUCTS_BEGIN,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  RESET_PRODUCT_DETAILS,
  CHANGE_INGREDIENT_VALUE,
  MOBILE_VIEW_HOW_TO_APPLY,
  MOBILE_INGREDIENT_PAGE,
  CLOSE_MOBILE_VIEW_HOW_TO_APPLY,
  CLOSE_MOBILE_INGREDIENT_PAGE,

} from '../constants/productActionTypes';
import { isMobile } from '../utils';

const isMobileDevice = isMobile();
const initialState = {
  productDetail: [],
  isLoading: true,
  howToApplyMobilePage: false,
  isMobile: isMobileDevice === 'ipad' || isMobileDevice === false ? false : true,
  ingredient: '',
  ingredientMobilePage: false,
  closeHowToApplyMobilePage: false,
  closeMobileIngredientPage: false,
  error: {}
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_PRODUCTS_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productDetails: action.payload
      };
    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case RESET_PRODUCT_DETAILS:
      return {
        ...state,
        initialState
      }
    case CHANGE_INGREDIENT_VALUE:
      return {
        ...state,
        ingredient: action.payload,
        ingredientMobilePage: state.isMobile ? true : false
      }
    case MOBILE_VIEW_HOW_TO_APPLY:
      return {
        ...state,
        howToApplyMobilePage: true,
        closeHowToApplyMobilePage: false,
      }
    case CLOSE_MOBILE_VIEW_HOW_TO_APPLY:
      return {
        ...state,
        closeHowToApplyMobilePage: true,
        howToApplyMobilePage: false
      }
    case CLOSE_MOBILE_INGREDIENT_PAGE:
      return {
        ...state,
        closeMobileIngredientPage: true,
        ingredientMobilePage: false
      }
    case MOBILE_INGREDIENT_PAGE:
      return {
        ...state,
        ingredientMobilePage: true
      }
    default:
      return state;
  }
}
